import type { AIModelChoices } from 'api';
import { Trans, useTranslation } from 'i18n';
import { Alert, AlertTitle, Link } from 'ui';

import { getGuideForModel } from '../../../help-guides';

export const NoAnalysisAlert = ({
  aiModel,
  testId = 'no-analysis-alert',
  variant = 'failed-analysis',
}: {
  aiModel: AIModelChoices;
  testId?: string;
  variant?: 'failed-analysis' | 'no-submitted-photos';
}) => {
  const { t } = useTranslation('features');
  const guide = getGuideForModel(aiModel);
  const descriptionKey =
    variant === 'no-submitted-photos'
      ? 'breakdowns.noAnalysisAlert.noSubmittedPhotosDescription'
      : 'breakdowns.noAnalysisAlert.description';

  return (
    <Alert severity="warning" data-testid={testId}>
      <AlertTitle>{t('breakdowns.noAnalysisAlert.title')}</AlertTitle>
      {t(descriptionKey)}
      {guide ? (
        <>
          <br />
          <br />
          <Trans
            i18nKey="breakdowns.noAnalysisAlert.guidance"
            namespace="features"
            values={{ guideLabel: t(guide.label) }}
            components={{
              guideLink: <Link href={guide.url} target="_blank" />,
            }}
          />
        </>
      ) : null}
    </Alert>
  );
};
